import { render } from "./supplierVoucher.vue?vue&type=template&id=5cfc7b0c&scoped=true"
import script from "./supplierVoucher.vue?vue&type=script&lang=js"
export * from "./supplierVoucher.vue?vue&type=script&lang=js"

import "./supplierVoucher.vue?vue&type=style&index=0&id=5cfc7b0c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cfc7b0c"]])

export default __exports__